export default {
  data() {
    return {
      qaLoaded: false
    }
  },

  methods: {
    setQALoaded(value) {
      this.qaLoaded = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/qaLoadedFlag.js